import { render } from "./AvatarCategoryBreadcrumb.vue?vue&type=template&id=4ec9d43d&scoped=true&ts=true"
import script from "./AvatarCategoryBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./AvatarCategoryBreadcrumb.vue?vue&type=script&lang=ts"

import "./AvatarCategoryBreadcrumb.vue?vue&type=style&index=0&id=4ec9d43d&scoped=true&lang=css"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec9d43d"]])

export default __exports__